import React, { useEffect, useState } from "react";
import "./smooth-loader.scss";

export default function SmoothLoader({ loading, skeleton, children, minTime = 200 }) {
    const [showSkeleton, setShowSkeleton] = useState(true);

    useEffect(() => {
        if (!loading) {
                setShowSkeleton(false);
        } else {
            setShowSkeleton(true);
        }
    }, [loading, minTime]);

    return (
        <div className={`smooth-wrapper row ${!showSkeleton ? "loaded" : ""}`}>
            <div className="smooth-skeleton">
                {skeleton}
            </div>

            <div className="smooth-content">
                {children}
            </div>
        </div>
    );
}
